import { useContext } from "react";
import { GlobalContextType, GlobalContext } from "./GlobalContextProvider";

export function useTccReasonContext() {
  const { tccReasons } = useContext<GlobalContextType>(GlobalContext);
  return tccReasons;
}
